<template>
    <li v-if="logedin"><a>Mein Konto</a>
        <ul>
            <li><a href="/gebotsliste">Gebotsliste</a></li>
            <li><a href="/beobachtungsliste">Beobachtungsliste</a></li>
            <li><a href="/zuschlagliste">Zuschlagliste</a></li>
            <li><a href="/profile">Meine Daten</a></li>
        </ul>
    </li>
</template>

<script>
    export default {
        props: {
            user: {
                type: [Boolean],
                required: true,
                default: false
            }
        },

        data () { 
            return {
                logedin: false
            }
        },

        created() {
            this.logedin = this.user;
            App.event.listen('login.success', (response) => {
                this.logedin = true;
            });
        }
    }
</script>
